import {
  createContext,
  useState,
  ReactNode,
  ReactElement,
  useMemo,
  useCallback,
} from 'react'

import { LoadingContextType } from '@types'

const LoadingContext = createContext<LoadingContextType | undefined>(undefined)

const LoadingProvider = ({
  children,
}: {
  children: ReactNode
}): ReactElement => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [loadingMessage, setLoadingMessage] = useState<string | null>(null)

  const showLoading = useCallback((message: string | null = null): void => {
    setLoadingMessage(message)
    setIsLoading(true)
  }, [])

  const hideLoading = useCallback((): void => {
    setIsLoading(false)
    setLoadingMessage(null)
  }, [])

  const contextValue = useMemo(
    () => ({
      isLoading,
      loadingMessage,
      showLoading,
      hideLoading,
    }),
    [isLoading, loadingMessage, showLoading, hideLoading]
  )

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
    </LoadingContext.Provider>
  )
}

export { LoadingContext, LoadingProvider }
